export default __webpack_public_path__ + "static/media/danger.9c2c32db.svg";